/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/

import React from 'react';
import PropTypes from 'prop-types';
import { getContentByLocal } from '../../../utils';

const getDefaultAnswer = (item, lang) => {
    let defaultAnswer = '';
    const { userAnswer, answers } = item;
    if (userAnswer && userAnswer.contents && userAnswer.contents.length > 0) {
        defaultAnswer = userAnswer.contents[0];
    } else if (userAnswer && userAnswer.chosenAnswerId && userAnswer.chosenAnswerId !== null) {
        const currentAnswer = answers && answers.filter(answer => answer.answerId === userAnswer.chosenAnswerId)
        if (currentAnswer && currentAnswer.length > 0) {
            defaultAnswer = getContentByLocal(currentAnswer[0].answerLocales, lang);
        } else {
            defaultAnswer = userAnswer.chosenAnswerId;
        }
    }
    return defaultAnswer
}
const getSubQuestion = (subQuestion, selectedLanguage, index, mainQuestionId) => {
     const {
        questionLocales,
        questionIndicator,
        questionId
    } = subQuestion;
    let defaultAnswer = getDefaultAnswer(subQuestion, selectedLanguage);
    const questionTitle = getContentByLocal(questionLocales, selectedLanguage);
    const questionTitleClass = questionTitle ? 'question-title' : '';
    let Q005 = '';
    if (mainQuestionId === 'Q001-003' || questionId === 'Q001-002-001') {
        !questionTitleClass && (Q005 = 'Q005')
        const chosenAnswer = subQuestion.userAnswer && subQuestion.userAnswer.chosenAnswerId;
        if (chosenAnswer && subQuestion.answers) {
            const chosenNewAnswer = parseInt(chosenAnswer.split(":")[1], 10) - 1;
            const leveLocales = subQuestion.answers[chosenNewAnswer].leveLocales || null;
            if (leveLocales) {
                defaultAnswer = getContentByLocal(leveLocales, selectedLanguage);
            } 
        }
    }

    return (defaultAnswer && <div key={index} className={`preview-list-ul ${Q005}`}>
        {questionTitle && <p className="preview-l" data-key={`questionTitle-${questionIndicator}`}>{questionTitle}</p>}
        <p className="preview-r" data-key={`Answer-${questionIndicator}`}>{defaultAnswer}</p>
    </div>)
}

const PreviewQuestionBasicInfo = (props) => {
    const {
        title,
        basicI18n,
        dataId,
        modifyInfo,
        selectedLanguage,
        handleChangeToEdit
    } = props;
    return(
        <div className="preview-list" data-id={dataId}>
            <h3 className="preview-h3">{title}
                <button className="btn btn-link title-modify" title={modifyInfo} onClick={(event) => handleChangeToEdit(event, 'basicInfo')}>
                    {modifyInfo}
                </button>
            </h3>
            <div className="preview-list-box">
            {
                basicI18n.questions && basicI18n.questions.map((question, index) => {
                    const {
                        subQuestions,
                        questionLocales,
                        questionId
                    } = question;
                    const questionTitle = getContentByLocal(questionLocales, selectedLanguage);
                    return (
                        <div key={index} className="preview-ul-ul">
                            <div className="preview-h4" data-key={`questionTitle-${index}`}>{questionTitle}</div>
                            {
                                subQuestions.map((subQuestion, subIndex) => {
                                    const subQuestionStep = subQuestion.subQuestions;
                                    if (subQuestionStep) {
                                        return subQuestionStep.map((item, itIndex) => {
                                            const subItemStep = item.subQuestions;
                                            if (subItemStep) {
                                                return item.subQuestions.map((subItem, itemIndex) => {
                                                    return getSubQuestion(subItem, selectedLanguage, itemIndex, questionId);
                                                })
                                            } else {
                                                return getSubQuestion(item, selectedLanguage, itIndex, questionId);
                                            }
                                        })
                                    } else {
                                        return getSubQuestion(subQuestion, selectedLanguage, subIndex, questionId);
                                    }
                                })
                            }
                        </div>
                    )
                })
            }
            </div>
        </div>
    );
};

PreviewQuestionBasicInfo.propType = {
    dataId: PropTypes.string.isRequired,
    modifyInfo: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    basicI18n: PropTypes.object.isRequired

};
export default PreviewQuestionBasicInfo;


// WEBPACK FOOTER //
// ./src/views/PreviewQuestion/components/PreviewQuestionBasicInfo.js